// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__15gpx","inputDescription":"styles_inputDescription__35n0Q"};